import { useState } from "react";
import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const PasswordField = (props: TextFieldProps) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  return (
    <TextField
      {...props}
      style={{ flexGrow: 1 }}
      type={passwordVisible ? "text" : "password"}
      variant="outlined"
      id="passwordFieldInput"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setPasswordVisible(!passwordVisible)}
              aria-label="toggle password visibility"
              edge="end"
              id="passwordFieldInputIconButton"
              size="large">
              {passwordVisible ? (
                <VisibilityIcon color="primary" id="passwordFieldInputPasswordOnIcon" />
              ) : (
                <VisibilityOffIcon color="primary" id="passwordFieldInputPasswordOffIcon" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}></TextField>
  );
};

export default PasswordField;
